// set up main hmi object
var hmi = {};

// the major global objects under the hmi namespace
hmi.dev = false; //set false when in production
hmi.tooltip = hmi.tooltip || {}; // For the tooltip system
hmi.utils = hmi.utils || {}; // Utility subsystem
hmi.models = hmi.models || {}; //stores all the possible models/components
hmi.charts = {}; //stores all the ready to use charts
hmi.logs = {}; //stores some statistics and potential error messages
hmi.dom = {}; //DOM manipulation functions
hmi.symbols = hmi.symbols || {};
hmi.dragBehavior = {};
hmi.components = hmi.components || [];
hmi.patterns = hmi.patterns || [];
hmi.constant = {
    VALV_1: 1,
    VALV_2: 2,
    TEXT: 3,
    L_PIPE: 4,
    R_PIPE: 5,
    PIPE: 6,
    PRESSURE: 7,
    TEMPERATURE: 8,
    TITLE_DESIGN: 9,
    VIS: 10,
    VOLTAGE: 11,
    BATTERY: 12,
    FIRE: 13,
    RELIEF_VALVE: 14,
    WATER_VALVE: 15,
    TANK_VALVE: 16,
    TANK: 17,
    FILTER_OBSTRUCTION: 18,
    WATER_LEVEL: 19,
    DOOR: 20,
    INJECTION: 21,
    COUNTER: 22,
    PRESSURE_REGULATOR: 23,
    LINE_VALVE: 24,
    T_CONNECTION_TOP: 25,
    T_CONNECTION_BOTTOM: 26,
    T_CONNECTION_LEFT: 27,
    T_CONNECTION_RIGTH: 28,
    PRESSURE_ALARM_MONITOR: 29,
    FLUID_COUNTER: 30,
    showMode: {
        design: 1,
        match: 2,
        monitor: 3
    },
    groupType: {
        component: 1,
        pipe: 2
    },
    pipeType: {
        line: 1,
        unionLT: 2,
        unionLB: 3,
        unionTR: 4,
        unionBR: 5
    },
    pipeTrace: {
        RL_F_H: 1,
        RL_I_H: 2,
        RL_F_TB: 3,
        RL_F_BT: 4,
        RL_I_TB: 5,
        RL_I_BT: 6,
        LR_F_H: 21,
        LR_I_H: 22,
        LR_F_TB: 23,
        LR_F_BT: 24,
        LR_I_TB: 25,
        LR_I_BT: 26,
        RRH: 41,
        RR_FT_H: 42,
        RR_IT_H: 43,
        RR_F_TBV: 44,
        RR_I_TBV: 45,
        RR_F_BTV: 46,
        RR_I_BTV: 47,
        LRH: 61,
        LLH: 62,
        LL_FT_H: 63,
        LL_IT_H: 64,
        LL_F_TBV: 65,
        LL_I_TBV: 66,
        LL_F_BTV: 67,
        LL_I_BTV: 68,
        BT_V_D: 71,
        BT_V_U: 72,
        BT_LR_D: 73,
        BT_LR_U: 74,
        BT_RL_D: 75,
        BT_RL_U: 76,
        TB_V_D: 81,
        TB_V_U: 82,
        TB_LR_D: 83,
        TB_LR_U: 84,
        TB_RL_D: 85,
        TB_RL_U: 86,
        TT_V_D: 91,
        TT_V_U: 92,
        TT_LR_D: 93,
        TT_LR_U: 94,
        TT_RL_D: 95,
        TT_RL_U: 96,
        BB_V_D: 101,
        BB_V_U: 102,
        BB_LR_D: 103,
        BB_LR_U: 104,
        BB_RL_D: 105,
        BB_RL_U: 106,
        TR_V_D: 111,
        TR_V_U: 112,
        TR_LR_D: 113,
        TR_LR_U: 114,
        TR_RL_D: 115,
        TR_RL_U: 116,
        TL_V_D: 121,
        TL_V_U: 122,
        TL_LR_D: 123,
        TL_LR_U: 124,
        TL_RL_D: 125,
        TL_RL_U: 126,
        LT_V_D: 131,
        LT_V_U: 132,
        LT_LR_D: 133,
        LT_LR_U: 134,
        LT_RL_D: 135,
        LT_RL_U: 136,
        RT_V_D: 141,
        RT_V_U: 142,
        RT_LR_D: 143,
        RT_LR_U: 144,
        RT_RL_D: 145,
        RT_RL_U: 146,
        BR_V_D: 151,
        BR_V_U: 152,
        BR_LR_D: 153,
        BR_LR_U: 154,
        BR_RL_D: 155,
        BR_RL_U: 156,
        BL_V_D: 161,
        BL_V_U: 162,
        BL_LR_D: 163,
        BL_LR_U: 164,
        BL_RL_D: 165,
        BL_RL_U: 166,
        LB_V_D: 171,
        LB_V_U: 172,
        LB_LR_D: 173,
        LB_LR_U: 174,
        LB_RL_D: 175,
        LB_RL_U: 176,
        RB_V_D: 181,
        RB_V_U: 182,
        RB_LR_D: 183,
        RB_LR_U: 184,
        RB_RL_D: 185,
        RB_RL_U: 186
    },
    pipeCPosition: {
        R: 1,
        L: 2,
        B: 3,
        T: 4
    },
    resizeRect: {
        leftTop: 1,
        leftBottom: 2,
        rigthTop: 3,
        rigthBottom: 4,
    },
    alignment: {
        horizontal: 1,
        vertical: 2
    },
    signals: {
        analog: 1,
        digital: 2,
        conection: 3,
        not_monitored: 4,
        digitalOrAnalog: 5,
        text: 6,
    },
    actions_status: {
        start: 0,
        waiting: 1,
        stop: 2
    },
    opacity: 0.60
};

// Node/CommonJS - require D3
if (typeof (module) !== 'undefined' && typeof (exports) !== 'undefined' && typeof (d3) == 'undefined') {
    d3 = require('d3');
}

hmi.dispatch = d3.dispatch('render_start', 'render_end');

// Function bind polyfill
// Needed ONLY for phantomJS as it's missing until version 2.0 which is unreleased as of this comment
// https://github.com/ariya/phantomjs/issues/10522
// http://kangax.github.io/compat-table/es5/#Function.prototype.bind
// phantomJS is used for running the test suite
if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
        if (typeof this !== "function") {
            // closest thing possible to the ECMAScript 5 internal IsCallable function
            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
        }

        var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP = function () { },
            fBound = function () {
                return fToBind.apply(this instanceof fNOP && oThis ?
                    this :
                    oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
            };

        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();
        return fBound;
    };
}

//  Development render timers - disabled if dev = false
if (hmi.dev) {
    hmi.dispatch.on('render_start', function (e) {
        hmi.logs.startTime = +new Date();
    });

    hmi.dispatch.on('render_end', function (e) {
        hmi.logs.endTime = +new Date();
        hmi.logs.totalTime = hmi.logs.endTime - hmi.logs.startTime;
        hmi.log('total', hmi.logs.totalTime); // used for development, to keep track of graph generation times
    });
}

// Logs all arguments, and returns the last so you can test things in place
// Note: in IE8 console.log is an object not a function, and if modernizr is used
// then calling Function.prototype.bind with with anything other than a function
// causes a TypeError to be thrown.
hmi.log = function () {
    if (hmi.dev && window.console && console.log && console.log.apply)
        console.log.apply(console, arguments);
    else if (hmi.dev && window.console && typeof console.log == "function" && Function.prototype.bind) {
        var log = Function.prototype.bind.call(console.log, console);
        log.apply(console, arguments);
    }
    return arguments[arguments.length - 1];
};

// print console warning, should be used by deprecated functions
hmi.deprecated = function (name, info) {
    if (console && console.warn) {
        console.warn('nvd3 warning: `' + name + '` has been deprecated. ', info || '');
    }
};

// The hmi.render function is used to queue up chart rendering
// in non-blocking async functions.
// When all queued charts are done rendering, hmi.dispatch.render_end is invoked.
hmi.render = function render(step) {
    // number of graphs to generate in each timeout loop
    step = step || 1;

    hmi.render.active = true;
    hmi.dispatch.render_start();

    var renderLoop = function () {
        var chart, graph;

        for (var i = 0; i < step && (graph = hmi.render.queue[i]); i++) {
            chart = graph.generate();
            if (typeof graph.callback == typeof (Function)) graph.callback(chart);
        }

        hmi.render.queue.splice(0, i);

        if (hmi.render.queue.length) {
            setTimeout(renderLoop);
        } else {
            hmi.dispatch.render_end();
            hmi.render.active = false;
        }
    };

    setTimeout(renderLoop);
};

hmi.render.active = false;
hmi.render.queue = [];

/*
Adds a chart to the async rendering queue. This method can take arguments in two forms:
hmi.addGraph({
    generate: <Function>
    callback: <Function>
})

or

hmi.addGraph(<generate Function>, <callback Function>)

The generate function should contain code that creates the NVD3 model, sets options
on it, adds data to an SVG element, and invokes the chart model. The generate function
should return the chart model.  See examples/lineChart.html for a usage example.

The callback function is optional, and it is called when the generate function completes.
*/
hmi.addGraph = function (obj) {
    if (typeof arguments[0] === typeof (Function)) {
        obj = {
            generate: arguments[0],
            callback: arguments[1]
        };
    }

    hmi.render.queue.push(obj);

    if (!hmi.render.active) {
        hmi.render();
    }
};

// Node/CommonJS exports
if (typeof (module) !== 'undefined' && typeof (exports) !== 'undefined') {
    module.exports = hmi;
}

if (typeof (window) !== 'undefined') {
    window.hmi = hmi;
}